import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  yearCard: {
    borderTop: `2px solid ${token.colorSplit}`,
    padding: '2px 8px',
    height: 168,
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    ':hover': {
      color: token.colorPrimary,
      borderTop: `2px solid ${token.colorPrimary}`,
      background: token.controlItemBgActive
    }
  },
  calendar: {
    marginTop: 24
  },
  result: {
    '.ant-result-icon>.anticon': {
      fontSize: '72px'
    },
    '.ant-result-title': {
      fontSize: 20,
      fontWeight: 700
    }
  },
  resultRoot: {
    padding: 0
  }
}))
